import { Button } from "@/components/ui/button";
import { useModalStore } from "@/zustand/modalStore";
import { useSheetStore } from "@/zustand/sheetStore";
import { useState } from "react";

type TransferOption = "card" | "wallet" | "user";

const options: { value: TransferOption; label: string; hint?: string }[] = [
  { value: "card", label: "Transfer to card" },
  {
    value: "wallet",
    label: "Transfer to wallet",
    hint: "Withdraw funds from your card to your wallet",
  },
  {
    value: "user",
    label: "Transfer to Dynascent Coin users",
    hint: "Dynascent Coin internal transfer, send via Email",
  },
];

const Transfer = () => {
  const [option, setOption] = useState<TransferOption>("card");
  const { openSheet } = useSheetStore();
  const { closeModal } = useModalStore();

  return (
    <div className="text-dark-text-50 mx-auto text-lg">
      <p className="text-lg font-semibold">Transfer</p>
      <p className="text-sm font-light">
        Please select where you would like to transfer from your available
        balance to
      </p>
      <div className="mt-4 space-y-2.5">
        {options.map(({ value, label, hint }) => (
          <div
            key={value}
            onClick={() => {
              setOption(value);
            }}
            className={`flex cursor-pointer items-center justify-between gap-4 rounded-lg border-[0.7px] px-2.5 py-3 text-sm ${
              option === value
                ? "bg-dark-background-widget border-dark-primary-main"
                : "border-dark-stroke-3"
            }`}
          >
            <div>
              <span>{label}</span>
              {hint && <p className="text-dark-text-300 text-xs">{hint}</p>}
            </div>
            <div
              className={`size-3 shrink-0 rounded-full border ${option === value ? "bg-dark-primary-main border-transparent" : "border-dark-primary-main"}`}
            />
          </div>
        ))}
      </div>
      <div className="mt-6">
        <Button
          onClick={() => {
            if (option === "card") openSheet("transfer2Card");
            else if (option === "wallet") openSheet("transfer2Wallet");
            // 2 steps: email entry, then the amount screen. `showSteps` is off
            // — the design has no step indicator, only the back arrow.
            else {
              openSheet("transfer2User", 2, undefined, false);
              // The chooser is done once the sheet is up; on desktop it
              // otherwise stays parked over the sheet behind its backdrop.
              closeModal();
            }
          }}
          className="text-dark-text-50 bg-dark-primary-main/80 hover:bg-dark-primary-main/60 mx-auto h-11 w-full rounded-md"
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default Transfer;
